import type { ReactNode } from "react";

import { css } from "@compiled/react";

import { token } from "@atlaskit/tokens";

import { wacToken } from "@/libraries/design/foundations";
import { checkFeatureFlagGate } from "@/utils/feature-flags/check-feature-flag.ts";
import { featureFlags } from "@/utils/feature-flags/feature-flag-manifest.ts";

export const Headings = ({
    main,
    sub
}: {
    main: ReactNode;
    sub?: ReactNode;
}) => {
    const visualFeedback = checkFeatureFlagGate(
        featureFlags.signupVisualAlignmentFeedback
    );
    return (
        <header css={headerCss}>
            <h1 css={mainHeadingCss}>{main}</h1>
            {sub && (
                <p
                    css={[
                        !visualFeedback && subHeadingCss,
                        visualFeedback && subHeadingVisualFeedbackCss
                    ]}
                >
                    {sub}
                </p>
            )}
        </header>
    );
};

const headerCss = css({
    display: "grid",
    gap: token("space.100"),
    hyphens: "auto",
    marginBlockEnd: token("space.200"),
    overflowWrap: "break-word",
    textAlign: "center",
    wordBreak: "break-word"
});

const mainHeadingCss = css({
    color: token("color.text"),
    fontFamily: wacToken("font.charlie.display"),
    fontSize: 32,
    fontWeight: 700,
    lineHeight: 1.25,
    margin: 0
});

const subHeadingCss = css({
    color: token("color.text"),
    lineHeight: 1.4,
    margin: 0
});

const subHeadingVisualFeedbackCss = css({
    fontSize: 14,
    lineHeight: 1.4,
    margin: 0
});
